import { baseAIURL } from './baseAIURL';

export function importFromTextURL(quizId: number) {
  const url = baseAIURL();
  url.pathname += `import-questions/${quizId}`;
  return url;
}
